import { useState } from 'react'
import { authenticatedFetch } from '../../utils/auth.js'
import { notifyPantryInventoryChanged } from '../pantry/pantryHelpers.js'
import {
  planFreshnessDay,
  planFreshnessPrompt,
  rememberFreshnessAnswer,
} from '../../utils/planFreshness.js'

/**
 * One question on a planned night that still counts an aging perishable as on hand.
 */
export default function PlanFreshnessAsk({ meal, onSettled }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const item = meal?.agingItem
  const day = planFreshnessDay(meal?.assignedTo)
  const prompt = planFreshnessPrompt(day, item?.name, item?.daysAgo)
  if (!prompt || !item?.id) return null

  async function answer(kind) {
    if (busy) return
    setBusy(true)
    setError('')
    try {
      const res = kind === 'keep'
        ? await authenticatedFetch(`/inventory/${encodeURIComponent(item.id)}`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: '{}',
        })
        : await authenticatedFetch(`/inventory/${encodeURIComponent(item.id)}`, {
          method: 'DELETE',
        })
      if (!res.ok) throw new Error('update failed')
      rememberFreshnessAnswer(meal.planItemId, meal.recipeId)
      notifyPantryInventoryChanged()
      onSettled?.()
    } catch {
      setError('Could not update your pantry. Try again.')
      setBusy(false)
    }
  }

  return (
    <div className="meal-freshness">
      <p className="meal-freshness-q">{prompt}</p>
      <div className="meal-freshness-actions">
        <button
          type="button"
          className="secondary"
          disabled={busy}
          onClick={(e) => {
            e.stopPropagation()
            answer('keep')
          }}
        >
          Still have it
        </button>
        <button
          type="button"
          className="secondary"
          disabled={busy}
          onClick={(e) => {
            e.stopPropagation()
            answer('used')
          }}
        >
          Used it up
        </button>
      </div>
      {error ? <p className="meal-freshness-error">{error}</p> : null}
    </div>
  )
}
